
import './App.css';
import { AuthProvider } from './context/authContext';
import Router from './routes/router';
import { PrimeReactProvider } from 'primereact/api';
import { ToastContainer } from 'react-toastify';
import "primereact/resources/themes/lara-light-blue/theme.css"; 

function App() {
  return (
    <AuthProvider value={{ authenticated: Boolean }}>
      <PrimeReactProvider value={{ ripple: true }}>

      <div className="bg-slate-50">
        <ToastContainer theme='colored' />
        <Router />
      </div>
      </PrimeReactProvider>

    </AuthProvider>
  );
}

export default App;
